var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "mb-1 smaller-font-content" }, [
        _vm._v(
          "This paid service enables this agency to pre-fill data in each product flow"
        )
      ]),
      _vm._v(" "),
      _c("b-form-checkbox-group", {
        attrs: { options: _vm.product, switches: "", stacked: "" },
        model: {
          value: _vm.preFillselected,
          callback: function($$v) {
            _vm.preFillselected = $$v
          },
          expression: "preFillselected"
        }
      }),
      _vm._v(" "),
      this.productFlag
        ? _c(
            "b-form-checkbox",
            {
              staticStyle: { "margin-left": ".75rem" },
              attrs: {
                id: "homecheckbox",
                name: "homecheckbox",
                disabled: this.product[0].disabled
              },
              on: {
                change: function($event) {
                  return _vm.homeReplacement($event)
                }
              },
              model: {
                value: _vm.isHomeReplacement,
                callback: function($$v) {
                  _vm.isHomeReplacement = $$v
                },
                expression: "isHomeReplacement"
              }
            },
            [_vm._v("\n      Include Home Replacement Cost\n    ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", [_vm._v("Agency Pre-Fill Settings")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32c8c976", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c8c976","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/agencies/PreFillProduct.vue
// module id = null
// module chunks = 